<template>
  <div>
    <div class="main-wrapper signin-form center signin-wrapper-padding">
      <div class="text-align-center margin-bottom-20 mm-logo"><img src="@/assets/MM-logo.png" /></div>
	    <h3 class="text-align-center margin-bottom-35">Sign In</h3>
      <flash-message autoHide variant="success"></flash-message>
      <flash-message autoHide variant="danger"></flash-message>
      <div v-show="login_errors" class="validate-warning-msg-login">{{ login_errors }}</div>
      <form @submit.prevent="onSubmit">
		    <div class="row margin-bottom-15">
		      <div class="col-12 col-sm-12">
      			<label
      					for="email"
      					class="col-12">Email address : <span class="required">*</span></label>
      			<input
      					type="email_addr"
      					name="email address"
      					id="email_addr"
      					class="col-12 col-sm-12 input-height-35"
      					ref="email_addr"
      					v-validate="'required'"
      					v-model="email_addr"
                maxlength="180">
      			<div v-show="verrors.has('email address')" class="validate-warning-msg">{{ verrors.first('email address') }}</div>
          </div>
        </div>
	      <div class="row margin-bottom-15">
		      <div class="col-12 col-sm-12">
      			<label
      					for="email"
      					class="col-12">Password : <span class="required">*</span></label>
      			<input
      					type="password"
      					name="password"
      					id="password"
      					class="col-12 col-sm-12 input-height-35"
      					ref="password"
      					v-validate="'required'"
      					v-model="password"
                maxlength="20">
      			<div v-show="verrors.has('password')" class="validate-warning-msg">{{ verrors.first('password') }}</div>
          </div>
        </div>
        <div class="submit margin-bottom-15">
          <button type="submit" class="btn btn-info btn-md">{{ signin_value }}</button>
        </div>
	      <div class="link"><router-link to="/forgot-password">Forgot your password?</router-link></div>
      </form>
    </div>
  </div>
</template>
<style scoped>
.mm-logo img{ width: 240px; }
</style>
<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import router from '../router/index.js';
import {login} from 'vuex';
import store from '../store/store.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  data: function () {
    return {
      email_addr: '',
      password: '',
      roles: [],
      admin_role_flag: '',
      manager_role_flag: '',
      mentor_role_flag: '',
      mentee_role_flag: '',
      instructor_role_flag: '',
      student_role_flag: '',
      login_errors: '',
      signin_value: 'Sign In'
    }
  },
  methods: {
  	onSubmit () {
      this.login_errors = '';
      this.$validator.validateAll().then((result) => {
        if(!result){
          return;
        }
        this.signin_value = 'Please Wait ...';
        this.login();
      }).catch(() => {
        // catches the error;
      });
  	},
    login: function () {
       let email = this.email_addr
       let password = this.password
       this.$store.dispatch('login', { email, password })
      .then((resp) => {
          document.body.className = '';
          this.signin_value = 'Sign in';
          let msg = '';
          let status = 'danger';
          this.$store.dispatch('set_flash_msg', { msg, status})
          this.userRedirection();
       })
      .catch(err => {
        this.signin_value = 'Sign in';
        if(this.$store.state.status == 'error') {
          this.login_errors = this.$store.state.err_message;
        }
      })
    },
  	navigate(path) {
  	  router.push(path);
  	},
    isInArray(value, array) {
      return array.indexOf(value) > -1;
    },
    userRedirect: function(role) {
      var url = '';
      if(role == 'Manager') {
        url = "/company-admin-dashboard";
      }
      else if(role == 'Mentor') {
        url = "/mentees-tasks-list";
      }
      else if(role == 'Primary Admin') {
        url = "/school-admin-dashboard";
      }
      else if(role == 'Instructor') {
        url = "/students-tasks-list";
      }
      return url;
    },
    userRedirection: function() {
      this.roles = this.$store.state.roles;
      if(this.roles) {
        this.admin_role_flag = this.isInArray('ROLE_MASTER_ADMIN', this.roles);
        this.manager_role_flag = this.isInArray('ROLE_ADMIN', this.roles);
        this.mentor_role_flag = this.isInArray('ROLE_MENTOR', this.roles);
        this.mentee_role_flag = this.isInArray('ROLE_MENTEE', this.roles);
        this.instructor_role_flag = this.isInArray('ROLE_INSTRUCTOR', this.roles);
        this.student_role_flag = this.isInArray('ROLE_STUDENT', this.roles);
        if(this.$store.state.switch_flag) {
          var url = this.userRedirect(this.$store.state.switch_flag);
          this.navigate(url);
        }
        else if(this.admin_role_flag === true) {
          this.navigate("/admin-dashboard");
        }
        else if(this.manager_role_flag === true) {
          if(this.$store.state.school_flag == 1) {
            this.navigate("/school-admin-dashboard");
          }
          else {
            this.navigate("/company-admin-dashboard");
          }
        }
        else if(this.mentor_role_flag === true) {
          this.navigate("/mentees-tasks-list");
        }
        else if(this.mentee_role_flag === true) {
          this.navigate("/mentee-dashboard");
        }
        else if(this.instructor_role_flag === true) {
          this.navigate("/students-tasks-list");
        }
        else if(this.student_role_flag === true) {
          this.navigate("/student-dashboard");
        }
        return true;
      }
    }
  },
  created: function () {
    document.body.className = 'login-page';
    this.userRedirection();
  }

}
</script>



// WEBPACK FOOTER //
// src/components/login.vue